import React from 'react'
import _ from 'underscore'
import AvailabilityTimeslot from './timeslot'

// Cell styling shared by the header/time cells. The selection colours live in
// timeslot.js; the table styling was migrated from the old .availability-table
// scss block.
const CELL_CLASSES = 'h-1 w-[50px] select-none border border-border p-0 text-center uppercase'

class AvailabilityMatrix extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      mode: '',
      timeslot: null
    }
  }

  render() {
    return (
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr>
            <td className={CELL_CLASSES}>Time</td>
            {_.map(this.props.availability.days, (day) => {
              return (
                <td key={day.ordinal} className={CELL_CLASSES}>
                  {day.name}
                </td>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {_.map(this.props.availability.periods, (period) => {
            const rowClassName = period.start.endsWith(':00') ?
              'border-t-2 border-t-muted-foreground'
            :
              ''

            return (
              <tr key={period.ordinal} className={rowClassName}>
                <td className={CELL_CLASSES}>
                  {period.start}
                </td>
                {_.map(this.props.availability.days, (day) => {
                  const timeslot = _.first(
                    _.select(this.props.availability.timeslots, function(timeslot) {
                      return ((timeslot.period_ordinal === period.ordinal) && (timeslot.day_ordinal === day.ordinal))
                    })
                  )

                  return (
                    <AvailabilityTimeslot
                      key={`${timeslot.day_ordinal}-${timeslot.period_ordinal}`}
                      timeslot={timeslot}
                      selected={timeslot.selected}
                      matching={timeslot.matching}
                      disabled={false}
                      mode={this.state.mode}
                      selectedIcon={this.props.selectedIcon}
                      otherIcon={this.props.otherIcon}
                      matchIcon={this.props.matchIcon}
                    />
                  )

                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
}

export default AvailabilityMatrix
